export default __webpack_public_path__ + "static/Крысиные бега_23-ce7a739671a1abcbdc0365570a3f3888.jpg";